import { ComponentesCompartidosModule } from './../componentes-compartidos/componentes-compartidos.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AutenticacionRoutingModule } from './autenticacion-routing.module';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';


@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    MatProgressSpinnerModule,
    CommonModule,
    ReactiveFormsModule,
    AutenticacionRoutingModule,
    ComponentesCompartidosModule
  ]
})
export class AutenticacionModule { }
